@if (isOpen) {
	<div class="container-fluid new-row p-2">
		<div style="text-align: start">
			<label>{{ "task" | langVal }}</label>
			<app-gen-input
				[actualObj]="task"
				[errors]="errors"
				fieldName="content"
				autofocus
				tabindex="10001"
				title_ph_lang="task"
				(keyupEvent)="validateEntireForm()"
			/>
		</div>
		<div
			class="d-flex flex-wrap gap-2 justify-content-between align-items-end flex-column flex-sm-row flex-nowrap"
		>
			<div>
				<div
					class="d-flex gap-2 gap-lg-4 my-2 justify-content-between flex-nowrap"
				>
					<app-date-picker
						class="colstat-small"
						[actualObj]="task"
						#datePicker
						[errors]="errors"
						fieldName="date"
						title_ph_lang="do_date"
						tabindex="-1"
						[addonObject]="{ after: { icon: 'calendar' } }"
					/>

					<app-time-picker
						class="colstat-time"
						#timePicker
						[actualObj]="task"
						[errors]="errors"
						fieldName="time"
						tabindex="-1"
						[addonObject]="{ after: { icon: 'time' } }"
					/>

					<!--				<app-gen-input-->
					<!--					style="width: 65px"-->
					<!--					autocomplete="off"-->
					<!--					[actualObj]="task"-->
					<!--					[errors]="errors"-->
					<!--					fieldName="repeat_days"-->
					<!--					tabindex="-1"-->
					<!--					(keyupEvent)="validateEntireForm()"-->
					<!--					[addonObject]="{ after: { text: ('days' | langVal) } }"-->
					<!--				/>-->

					<app-gen-autocomplete
						#personFuzzyInput
						title_ph_lang="patient_contact"
						tabindex="-1"
						[searchStr]="patientRow?.name || ''"
						[disabled]="!!patientRow?.name"
						[fuzzySearchableClasses]="
							permsService?.perms?.administrative
								? ['patients', 'contacts']
								: ['patients']
						"
						(chosenEvent)="choosePatientOrContact($event)"
					/>
				</div>

				@if (permsService.owner_has_users) {
					<div class="my-2">
						<label>{{ "recipients" | langVal }}</label>
						<app-autocomplete-with-tags
							(chosenEvent)="updateSubUsers($event)"
							title_ph_lang="recipients"
							tabindex="-1"
							[fuzzySearchableClasses]="['sub_users', 'sub_user_groups']"
						/>
					</div>
				}
			</div>

			<app-btn-ext
				text="add"
				class="my-2"
				[disabled]="!isFormSubmittable"
				tabindex="10002"
				(clickEv)="submit()"
				[isSpin]="isSaving"
			/>
			<app-btn-ext
				text="task_scheduler"
				class="my-2"
				[disabled]="!isFormSubmittable"
				tabindex="10002"
				(clickEv)="modalProps = {}"
			/>
		</div>

		<!--<div class="form-group row">-->

		<!--  <div class="col-4 col-lg-3">-->
		<!--    <app-gen-button-group [actualObj]="task" fieldName="email_notify" optionsListName="email_notify_opts"-->
		<!--      (changeEvent)="validateEntireForm()" [disabled]=" !permsService?.perms?.administrative" />-->
		<!--  </div>-->
		<!--  <div class="col-4 col-lg-3">-->
		<!--    <app-gen-button-group [actualObj]="task" fieldName="confident" optionsListName="confident_opts"-->
		<!--      (changeEvent)="validateEntireForm()" [disabled]=" !permsService?.perms?.administrative" />-->
		<!--  </div>-->
		<!--  <div class="col-4 col-lg-3">-->
		<!--    <app-gen-button-group [actualObj]="task" fieldName="sms_notify" optionsListName="sms_notify_opts"-->
		<!--      (changeEvent)="validateEntireForm()" [disabled]=" !permsService?.perms?.administrative" />-->
		<!--  </div>-->
		<!--</div>-->
		<!--<div class="form-group row">-->
		<!--  <div class="col-4 col-lg-3">-->
		<!--    <app-gen-button-group [actualObj]="task" fieldName="closed" optionsListName="closed_opts" (changeEvent)="validateEntireForm()" [disabled]=" !permsService?.perms?.administrative" />-->
		<!--  </div>-->
		<!--  <div class="col-4 col-lg-3">-->
		<!--    <app-gen-button-group [actualObj]="task" fieldName="urgent" optionsListName="urgent_opts"-->
		<!--      (changeEvent)="validateEntireForm()" [disabled]=" !permsService?.perms?.administrative" />-->
		<!--  </div>-->
		<!--</div>-->
	</div>
} @else {
	<button
		class="btn btn-icon open-patient-form"
		(click)="isOpen = true"
		titleLang="add"
		icon="plus"
	></button>
}
@if (modalProps) {
	<app-modal-wrap
		(onClose)="modalProps = null; onSchedulerClose.emit($event)"
		title="create_scheduler"
	>
		<app-task-scheduler
			(onClose)="modalProps = null; onSchedulerClose.emit($event)"
			[patient_id]="task.patient_id"
			[content]="task.content"
		/>
	</app-modal-wrap>
}
